import {defineStore} from 'pinia'
import { defaultComponentsData, DRAWING_STATE, FLOOR_STATE } from '../studio/constants'
import { main } from '../../main';

export const useStudioStore = defineStore('studioStore', {
    state : () => ({
        currentAppState: FLOOR_STATE,
        basePolygonDrawn: false,
        atleast3PointsDrawn: false,
        obstructionPlacedInScene: false,
        undoEnabled : false,
        zoomValue : 3,
        openObstructionHeight:false,
        obstructionHeight:0,
        obstructionType:null,
        isObstructionSelected:false,
        infoFormData:{
            floorValue: null,
            supply_phase: 'Single Phase',
            tariff_rate: 7,
            monthly_bill: null,
            sanction_load: null,
          },
          gifBtnToggle: false,
          rotationValue:90,
    }),
    actions: {
        OPEN_OBSTRUCTION_HEIGHT(status){
            this.openObstructionHeight=status;
this.atleast3PointsDrawn=false;
        },
        SET_OBSTRUCTION_HEIGHT(height){
            this.obstructionHeight=height;
            this.isObstructionSelected=true;
        },
        SET_OBSTRUCTION_TYPE(type){
            this.obstructionType=type;
        },
        UPDATE_INFORMATION_FORM(formData){
            this.infoFormData=formData;
        },
        SET_INFORMATION_FORM_DATA_STORE() {
              this.currentAppState= DRAWING_STATE;
            if (this.currentAppState === DRAWING_STATE) {
              if(!this.basePolygonDrawn){
                main.app.config.globalProperties.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
              }
              else {
                main.app.config.globalProperties.$stageInstance.polygonModel.updateHeightOnFloorChange(this.infoFormData.floorValue);
                main.app.config.globalProperties.$stageInstance.floorValue = this.infoFormData.floorValue;
            }
            }
            this.setFloorValueInLocalStorage(this.infoFormData);
            this.setAppStateInLocalStorage(DRAWING_STATE);
            this.gifContent = this.gifContentForDrawing;
            this.gifBtnToggle = true;
          },
          setFloorValueInLocalStorage(infoData = 0) {
            let componentJSON = localStorage.getItem('componentData') ? JSON.parse(localStorage.getItem('componentData')) : defaultComponentsData();
            componentJSON.floorValue = infoData?.floorValue||0;
            componentJSON.infoData=infoData;
            localStorage.setItem('componentData', JSON.stringify(componentJSON));
            if(localStorage.getItem('stageData')){
                let savedStageData = JSON.parse(localStorage.getItem('stageData'));
                savedStageData.floorValue = infoData?.floorValue||0;
                localStorage.setItem('stageData', JSON.stringify(savedStageData));
            }
          },
          setAppStateInLocalStorage(appState = FLOOR_STATE) {
            localStorage.setItem('currentAppState', appState);
          },
    }
})